import { Link } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import Avatar from '@guestyci/foundation/Avatar';
import createStyles from '@guestyci/foundation/createStyles';
import TextField from '@guestyci/foundation/TextField';
import utils from 'utils';
import defaultTheme from '@guestyci/foundation/theme/defaultTheme';
import { Menu, MenuItem } from '@guestyci/foundation/Menu';
import navigationsRoute from '../../routes/navigationsRoute';

const useStyles = createStyles((theme: typeof defaultTheme) => ({
  root: {
    backgroundColor: theme.palette.background.white,
    width: '2rem',
    height: '2rem',
    'user-select': 'none',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  text: {
    color: `${theme.palette.secondary.default} !important`,
    whiteSpace: 'nowrap',
    fontSize: '18px',
    lineHeight: '20px',
    fontWeight: 700,
    wordSpacing: -5,
  },

  dropDown: {
    backgroundColor: theme.palette.background.white,
    marginTop: 8,
    padding: '0.5rem 0',
    borderRadius: '2px',
    boxShadow:
      '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12)',
    '& a': {
      color: theme.palette.text.default,
      fontSize: '14px',
      lineHeight: '1.3',
      fontWeight: 400,
      '&:hover': {
        color: theme.palette.text.link,
        textDecoration: 'none',
      },
    },
  },
}));

function generateAvatarByName() {
  const { authenticatedData } = utils.getLocalStorageByKey('authenticatedData');
  const {
    firstName = '',
    lastName = '',
    username,
  } = authenticatedData?.baseUserInfo;

  return `${firstName?.[0] || username?.[0]} ${lastName?.[0] || ''}`;
}

function UserNavigationBar() {
  const classes = useStyles();
  const [userAvatar, setUserAvatar] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const menuAnchor = useRef();

  useEffect(() => {
    setUserAvatar(generateAvatarByName());
  }, []);

  const togglePopUp = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="mx-4">
      <Avatar
        className={classes.root}
        onClick={togglePopUp}
        data-qa="user-avatar"
        ref={menuAnchor}
      >
        <TextField className={classes.text} bold>
          {userAvatar.toLocaleUpperCase()}
        </TextField>
      </Avatar>
      <Menu
        data-qa="user-nav-menu"
        className={classes.dropDown}
        anchor={menuAnchor}
        open={isOpen}
        onClose={() => setIsOpen(false)}
        variant="menu"
        menuWidth={115}
        fitAnchor
        anchorDirection="end"
      >
        <Link to={navigationsRoute.ACCOUNT}>
          <MenuItem onClick={togglePopUp}>My Account</MenuItem>
        </Link>
        <Link to={navigationsRoute.LOGOUT}>
          <MenuItem onClick={togglePopUp}>Logout</MenuItem>
        </Link>
      </Menu>
    </div>
  );
}

export default UserNavigationBar;
